import { useState } from 'react'
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Grid, Typography,
} from '@mui/material'

// Apertura del proceso de cobro / caja (port de procesocobroagil-modal.html).
export default function ProcesoCobroModal({ open, caja, usuario, onConfirm, onClose, loading }) {
  const [montoBaseEfectivo, setMontoBaseEfectivo] = useState(0)

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Apertura de proceso de cobro</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          No hay un proceso de cobro abierto para esta caja. Abrí uno para continuar con la facturación.
        </Typography>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={6}>
            <TextField fullWidth size="small" label="Caja" value={caja?.nombre || '—'} InputProps={{ readOnly: true }} />
          </Grid>
          <Grid item xs={6}>
            <TextField fullWidth size="small" label="Usuario" value={usuario || '—'} InputProps={{ readOnly: true }} />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth size="small" type="number" label="Monto base en efectivo"
              value={montoBaseEfectivo} onChange={(e) => setMontoBaseEfectivo(e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" color="secondary" disabled={loading}
          onClick={() => onConfirm({ montoBaseEfectivo: Number(montoBaseEfectivo) })}>
          Abrir proceso de cobro
        </Button>
      </DialogActions>
    </Dialog>
  )
}
